import { useState } from 'react';
import { errorMessage } from '../api/client';
import { useAuth } from '../api/auth';
import { Field, TextInput } from '../components/ui';

export function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);

    try {
      await signIn(email.trim(), password);
    } catch (caught) {
      setError(errorMessage(caught));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <h1>Pathology admin</h1>
        <p className="muted">
          Sign in with an admin account. New ones are made on the server with
          <code> npm run admin:create</code>.
        </p>

        <Field label="Email">
          <TextInput value={email} onChange={setEmail} type="email" placeholder="admin@example.com" />
        </Field>
        <Field label="Password">
          <TextInput value={password} onChange={setPassword} type="password" />
        </Field>

        {error ? <p className="status status-error">{error}</p> : null}

        <button className="button" type="submit" disabled={busy || !email || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
